// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2769":"7936db9b","2924":"dfac8e5f","6847":"125e5e95","8410":"510d96d4","9596":"786da6ff","9974":"7439babe"}[chunkId] + ".chunk.css";
};